module.exports = __webpack_public_path__ + "img/other3.dfdac66a.png";